<template>
  <div class="anchor-wrapper">
    <ul ref="tabs" :style="calcStyle" class="anchor-tab" :class="tabType">
      <li
        v-for="(item, index) in tabs.data"
        :key="index"
        :class="{ active: index === curTabIndex }"
        @click="changeTab(index, $event)"
      >
        <div class="content">
          <div
            class="title"
            :style="{
              color:
                curTabIndex === index
                  ? tabs.style.selectedTitleColor
                  : tabs.style.unselectTitleColor
            }"
          >
            {{ item.title }}
          </div>
          <div
            class="sub-title"
            :style="{
              color:
                curTabIndex === index
                  ? tabs.style.selectedSubTitleColor
                  : tabs.style.unselectSubTitleColor,
              backgroundColor:
                curTabIndex === index ? tabs.style.subTitleBgColor : ''
            }"
          >
            {{ item.subTitle }}
          </div>
        </div>
        <div
          v-if="tabs.data && index != tabs.data.length - 1"
          class="right-border"
        />
      </li>
    </ul>
    <img src="@/images/category_feed/shadow.png" class="shadow" />
  </div>
</template>
<script>
import { ossImage } from '@/utils/oss_image'
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Object,
      default: () => ({})
    },
    curTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    calcStyle() {
      const styleAttr = {}
      if (
        this.tabs.style &&
        this.tabs.style.bgImg &&
        this.tabs.style.bgImg.img_url
      ) {
        styleAttr['background-image'] = `url(${ossImage({
          src: this.tabs.style.bgImg.img_url,
          width: 750
        })})`
        styleAttr['background-size'] = '100% 100%'
        styleAttr['background-repeat'] = 'no-repeat'
      } else {
        styleAttr['background-color'] = '#fff'
      }
      const listBg = Object.keys(styleAttr).reduce((s, key) => {
        const attrStr = `${key}: ${styleAttr[key]};`
        return s + attrStr
      }, '')
      return listBg
    },
    tabType: function () {
      const len = this.tabs?.data?.length || 0
      return {
        'can-scroll': len > 4
      }
    }
  },
  methods: {
    changeTab(index, e) {
      this.scrollHorizontal(index, e)
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('changeTab', {
        curTabIndex: index
      })
    },
    scrollHorizontal(index, e) {
      if (index < 0) index = 0
      const scrollContainer = this.$refs.tabs
      const start = scrollContainer.scrollLeft
      const target = this.calScrollLeft(index)
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          this.animation(scrollContainer, start, target, start < target)
        })
      } else {
        scrollContainer.scrollLeft = this.calScrollLeft(index)
      }
    },

    calScrollLeft(index) {
      const singleWidth = 93
      let target = index * singleWidth
      target = Math.max(0, target)
      target = Math.min(singleWidth * this.tabs?.data?.length || 0, target)
      return Math.abs(target)
    },
    animation(dom, start, target, toRight) {
      start += toRight ? 8 : -8
      // eslint-disable-next-line no-mixed-operators
      if (start > target === toRight) return
      dom.scrollLeft = start
      window.requestAnimationFrame(
        this.animation.bind(this, dom, start, target, toRight)
      )
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variable.scss';
@import '@/styles/mixin.scss';
.anchor-wrapper {
  display: flex;

  position: -webkit-sticky;
  position: sticky;
  top: 44px;
  z-index: 3;

  width: 100%;
  height: 50px;

  color: #fff;
  .anchor-tab {
    display: flex;

    // transform: translate3d(0, 0, 0);

    width: 100%;

    align-items: center;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;

    li {
      position: relative;

      flex: 1;

      text-align: center;
      @include flex-row-between;
      .content {
        display: flex;

        flex: 1;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 0.32rem;
          color: $c-text-title;
        }
        .sub-title {
          width: 1.32rem;
          height: 0.36rem;
          overflow: hidden;

          font-size: 0.22rem;
          white-space: nowrap;
          @include flex-row-center;
        }
      }
      .right-border {
        width: 0.02rem;
        height: 0.4rem;

        background-color: #cccccc;
      }
      &.active {
        .content {
          .title {
            font-weight: 600;
            color: $theme-main;
          }
          .sub-title {
            background-color: #19c55b;
            border-radius: 0.18rem;

            color: #ffffff;
          }
        }
      }
    }
    &.can-scroll {
      li {
        width: 1.86rem;

        flex: none;
      }
    }
  }
  .anchor-tab::-webkit-scrollbar {
    display: none;
  }
  .shadow {
    position: absolute;
    top: 0;
    right: 0;

    width: 25px;

    height: 50px;
  }
}
</style>
